import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, Dropdown } from "react-bootstrap";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import { EmployeeLink } from "components/Employees/EmployeeEditDrawer";
import {
	FiPlus,
	FiMoreHorizontal,
	FiPaperclip,
	FiAlertTriangle,
	FiUpload,
} from "react-icons/fi";
import Moment from "react-moment";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { errorFormating, isAdmin, isSupervisor } from "utils/utils";
import * as expensesActions from "actions/expensesActions";
import { getSelectableEmployees } from "actions/employeesActions";
import ExpenseEditModal from "components/Expenses/ExpenseEditModal";
import ExpensePaymentModal from "components/Expenses/ExpensePaymentModal";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import { appService, expensesService, expStatus } from "services";
import Loading from "components/Loading";
import Layout from "components/Layout";
import Modal from "components/Modal";
import DataTable from "components/DataTable/DataTable";
import "components/Expenses/Expenses.scss";
import ExpenseNavigationTabs from "components/Expenses/ExpenseNavigationTabs";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

class Expenses extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filterProviderId: "",
			filterExpenseTypeId: "",
			filterStatus: "",
			filterEmployeeId: "",
			startDate: null,
			endDate: null,
			focusedInput: null,
			isLoading: true,
		};
		this.closeModal = this.closeModal.bind(this);
		this.openNewExpenseModal = this.openNewExpenseModal.bind(this);
		this.openEditExpenseModal = this.openEditExpenseModal.bind(this);
		this.openCancelExpenseModal = this.openCancelExpenseModal.bind(this);
		this.getExpenses = this.getExpenses.bind(this);
		this.employeeSelectFetchOptions = { enabled: true };
	}

	async componentDidMount() {
		await Promise.all([
			this.getExpenses(),
			this.props.getAllExpenseTypes(),
			this.props.getAllExpenseGroupings(),
			this.props.getAllPaymentTypes(),
			this.props.getAllProviders(),
			this.props.getAllExpenseStatus(),
			this.props.getSelectableEmployees(),
		]);
		this.setState({ isLoading: false });
	}

	handleChangeSearch = (event) => {
		const targetId = event.target.id;

		this.setState(
			{
				[targetId]: event.target.value,
			},
			() => {
				this.getExpenses();
			}
		);
	};

	handleEmployeeFilterChange = (idOrNull) => {
		this.setState({ filterEmployeeId: idOrNull || "" }, () =>
			this.getExpenses()
		);
	};

	getSearchFilters = () => {
		const canSupervise = isAdmin() || isSupervisor();
		return {
			provider_id: this.state.filterProviderId,
			expense_type_id: this.state.filterExpenseTypeId,
			status: this.state.filterStatus,
			date_from: this.state.startDate,
			date_to: this.state.endDate,
			employee_id: canSupervise
				? this.state.filterEmployeeId
				: this.props.user?.id,
		};
	};

	async getExpenses() {
		await this.props.getAllExpenses(this.getSearchFilters());
	}

	onDatesChange = ({ startDate, endDate }) => {
		if (startDate) startDate = startDate.format("YYYY-MM-DD");
		if (endDate) endDate = endDate.format("YYYY-MM-DD");

		this.setState({ startDate, endDate }, () => this.getExpenses());
	};

	closeModal() {
		this.props.hideModal();
	}

	openEditExpenseModal(expense) {
		const { t } = this.props;
		const disabled = expense.status !== expStatus.pending;
		this.props.showModal(
			{
				open: true,
				title: disabled ? t("expenses.viewExpense") : t("expenses.editExpense"),
				style: { width: "600px" },
				content: (
					<ExpenseEditModal
						expense={expense}
						disabled={disabled}
						getExpenses={this.getExpenses}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewExpenseModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.newExpense"),
				style: { width: "600px" },
				content: (
					<ExpenseEditModal
						handleClose={this.closeModal}
						getExpenses={this.getExpenses}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openCancelExpenseModal(expense) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.cancelExpense"),
				style: { width: "400px" },
				message: t("expenses.cancelConfirm"),
				deleteAction: () => this.confirmCancel(expense),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openPaymentModal(expense) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("expenses.addPayment"),
				style: { width: "500px" },
				content: (
					<ExpensePaymentModal
						expense={expense}
						employees={this.props.select_employees}
						currentUser={this.props.user}
						getExpenses={this.getExpenses}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(title, message) {
		this.props.showModal(
			{
				open: true,
				title: title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleExport = async () => {
		const response = await expensesService.exportList({
			...this.getSearchFilters(),
			time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		});

		if (!response.ok) {
			this.openAlertModal(
				this.props.t("expenses.exportErrorTitle"),
				this.props.t("expenses.exportError")
			);
			return;
		}

		this.props.showModal(
			{
				open: true,
				title: this.props.t("expenses.exportTitle"),
				style: { width: "400px" },
				confirmText: this.props.t("common.download"),
				loadingText: this.props.t("common.downloading"),
				message: this.props.t("expenses.exportSuccess"),
				closeModal: this.closeModal,
				confirmAction: () => this.downloadExport(response.access_token),
			},
			"confirm"
		);
	};

	downloadExport = async (token) => {
		this.props.updateModalLoading(true);
		const response = await appService.getExported(token);
		const url = window.URL.createObjectURL(response);
		const link = document.createElement("a");
		document.body.appendChild(link);
		link.href = url;
		link.download = "gastos.xlsx";
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);
		this.props.updateModalLoading(false);
		this.closeModal();
	};

	confirmCancel = async (expense) => {
		const updated = {
			id: expense.id,
			day: expense.day,
			value: expense.value,
			type_id: expense.type_id ?? expense.type?.id,
			provider_id: expense.provider_id ?? expense.provider?.id,
			comments: expense.comments,
			answer_comments: expense.answer_comments,
			payer_comments: expense.payer_comments,
			status: expStatus.canceled,
		};
		const response = await expensesService.update(updated);
		this.closeModal();

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t("expenses.errorCancel"), textError.general);
		} else {
			this.getExpenses();
		}
	};

	getActions = (expense) => {
		const { t } = this.props;
		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item
						as="button"
						onClick={() => this.openEditExpenseModal(expense)}
					>
						{expense.status !== expStatus.pending ? t("common.view") : t("common.edit")}
					</Dropdown.Item>
					{expense.status === expStatus.approved && (
						<Dropdown.Item
							as="button"
							onClick={() => this.openPaymentModal(expense)}
						>
							{t("expenses.addPayment")}
						</Dropdown.Item>
					)}
					{expense.status === expStatus.pending && (
						<Dropdown.Item
							as="button"
							onClick={() => this.openCancelExpenseModal(expense)}
						>
							{t("common.cancel")}
						</Dropdown.Item>
					)}
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	downloadAttachment = async (expense) => {
		const attachment = expense.attachments[0];
		const response = await expensesService.getAttachment(
			expense.id,
			attachment.url
		);
		const url = window.URL.createObjectURL(response);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = attachment.name;
		a.click();
	};

	getDesktopColumns = () => {
		const { t } = this.props;
		const canSupervise = isAdmin() || isSupervisor();
		const columns = [];

		if (canSupervise) {
			columns.push({
				key: "requester",
				header: t("expenses.columns.requester"),
				sortable: false,
				render: (expense) => {
					const employee = expense.requester;
					return (
						<div className="employee-info-wrapper">
							<div className="employee-avatar-wrapper">
								{employee?.name ? employee.name.charAt(0).toUpperCase() : ""}
								{employee?.surname
									? employee.surname.charAt(0).toUpperCase()
									: ""}
							</div>
							<div className="employee-details">
								<div className="flex flex-row">
									<EmployeeLink
										employee={employee}
										className="employee-name-link"
									>
										{employee ? `${employee.name} ${employee.surname}` : ""}
									</EmployeeLink>
								</div>
								<div className="employee-meta">
									<Moment format="DD/MM/YYYY HH:mm">{expense.requested}</Moment>
								</div>
							</div>
						</div>
					);
				},
			});
		}

		columns.push({
			key: "day",
			header: t("expenses.columns.date"),
			render: (expense) => <Moment format="DD/MM/YYYY">{expense.day}</Moment>,
		});

		if (!canSupervise) {
			columns.push({
				key: "requested",
				header: t("expenses.columns.requested"),
				render: (expense) => (
					<Moment format="DD/MM/YYYY HH:mm">{expense.requested}</Moment>
				),
			});
		}

		columns.push(
			{
				key: "value",
				header: t("expenses.columns.amount"),
				render: (expense) => {
					const maxValue = expense.type?.max_value;
					const exceeded = maxValue && parseFloat(expense.value) > parseFloat(maxValue);
					return (
						<span className={exceeded ? "expense-value-exceeded" : undefined}>
							{expense.value} €
							{exceeded && (
								<FiAlertTriangle
									className="icon-limit-exceeded"
									title={t("expenses.columns.limitExceeded")}
								/>
							)}
						</span>
					);
				},
			},
			{
				key: "type_name",
				header: t("expenses.columns.category"),
				render: (expense) => {
					const typeObj = expense.type ?? this.props.expense_types.find((et) => et.id === expense.type_id);
					return (
						<span
							className="expense-type-tag"
							style={{
								backgroundColor: typeObj?.background_color || undefined,
								border: typeObj?.border_color ? `2px solid ${typeObj.border_color}` : undefined,
							}}
						>
							{typeObj?.name ?? expense.type_name}
						</span>
					);
				},
			},
			{
				key: "answered",
				header: t("expenses.columns.approved"),
				render: (expense) =>
					expense.answered ? (
						<Moment format="DD/MM/YYYY HH:mm">{expense.answered}</Moment>
					) : (
						"—"
					),
			},
			{
				key: "paid",
				header: t("expenses.columns.paid"),
				render: (expense) =>
					expense.paid ? (
						<Moment format="DD/MM/YYYY HH:mm">{expense.paid}</Moment>
					) : (
						"—"
					),
			},
			{
				key: "status",
				header: t("expenses.columns.status"),
				render: (expense) => (
					<span className={`estado ${expense.status}`}>
						{t(`expenses.statusLabels.${expense.status}`, { defaultValue: expense.status })}
					</span>
				),
			},
			{
				key: "attachments",
				header: "",
				sortable: false,
				cellClassName: "td-icon",
				render: (expense) =>
					expense.attachments?.length > 0 ? (
						<button
							type="button"
							className="btn btn-icon"
							title="Descargar adjunto"
							onClick={() => this.downloadAttachment(expense)}
						>
							<FiPaperclip />
						</button>
					) : null,
			}
		);

		return columns;
	};

	getTableRowsMobile = () =>
		this.props.expenses.map((expense) => (
			<tr key={expense.id}>
				<td className="td-name">
					<button
						className="btn-transparent btn-editable"
						onClick={() => this.openEditExpenseModal(expense)}
					>
						{expense.requester?.name} {expense.requester?.surname}
					</button>
					<br />
					<Moment format="DD/MM/YYYY">{expense.day}</Moment>
				</td>
				<td>
					<span
						className={`expense-value${expense.type?.max_value && parseFloat(expense.value) > parseFloat(expense.type.max_value) ? " expense-value-exceeded" : ""}`}
					>
						{expense.value} €
						{expense.type?.max_value &&
							parseFloat(expense.value) >
								parseFloat(expense.type.max_value) && (
								<FiAlertTriangle
									className="icon-limit-exceeded"
									title="Límite de gasto superado"
								/>
							)}
					</span>
				</td>
				<td>
					<span className={`estado ${expense.status}`}>
						{this.props.t(`expenses.statusLabels.${expense.status}`, { defaultValue: expense.status })}
					</span>
				</td>
				<td className="td-actions">{this.getActions(expense)}</td>
			</tr>
		));

	getEmptyRow = () => {
		return <p>{this.props.t("expenses.noResults")}</p>;
	};

	getContent = () => {
		if (this.state.isLoading) {
			return <Loading />;
		}

		if (this.props.error) {
			return this.props.t("expenses.errorLoading");
		}

		if (this.props.expenses == undefined || this.props.expenses.length === 0)
			return this.getEmptyRow();

		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-expenses table-mobile">
							<tbody>{this.getTableRowsMobile()}</tbody>
						</table>
					</div>
				</Mobile>
				<TabletOrDesktop>
					<DataTable
						tableClassName="table-expenses table-desktop table-hover"
						columns={this.getDesktopColumns()}
						rows={this.props.expenses}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t("expenses.noResults")}
						actionsColumn={{
							render: (expense) => this.getActions(expense),
							className: "td-actions",
						}}
					/>
				</TabletOrDesktop>
			</>
		);
	};

	render() {
		const { expense_types, expense_status, providers } = this.props;
		const {
			filterProviderId,
			filterExpenseTypeId,
			filterStatus,
			filterEmployeeId,
			startDate,
			endDate,
			focusedInput,
		} = this.state;

		return (
			<>
				<Layout className="page-expenses" context="expenses">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{this.props.t("expenses.title")}</h1>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t("expenses.createExpense")}
								onClick={this.openNewExpenseModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item as="button" onClick={this.handleExport}>
										<FiUpload className="dropdown-icon" />{" "}
										{this.props.t("expenses.exportToExcel")}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<ExpenseNavigationTabs />

					<div className="subheading">
						<div className="subheading-filters">
							{(isAdmin() || isSupervisor()) && (
								<>
									<EmployeeSelectSearch
										className="form-select-user"
										controlId="filterEmployeeId"
										multiple={false}
										value={filterEmployeeId || null}
										onChange={this.handleEmployeeFilterChange}
										fetchOptions={this.employeeSelectFetchOptions}
										placeholder={this.props.t("common.searchEmployee")}
										allLabel={this.props.t("expenses.allEmployees")}
									/>
									<FormGroup
										className="form-group form-search"
										controlId="filterProviderId"
									>
										<FormControl
											as="select"
											value={filterProviderId}
											onChange={this.handleChangeSearch}
										>
											<option value="">{this.props.t("expenses.allProviders")}</option>
											{providers.length > 0 &&
												providers.map((item) => (
													<option key={item.id} value={item.id}>
														{item.name}
													</option>
												))}
										</FormControl>
									</FormGroup>
								</>
							)}

							<FormGroup
								className="form-group form-search"
								controlId="filterStatus"
							>
								<FormControl
									as="select"
									value={filterStatus}
									className="form-search"
									onChange={this.handleChangeSearch}
								>
									<option value="">{this.props.t("expenses.allStatuses")}</option>
									{expense_status.length > 0 &&
										expense_status.map((item) => (
											<option key={item.id} value={item.name}>
												{item.name}
											</option>
										))}
								</FormControl>
							</FormGroup>

							<FormGroup
								className="form-group form-search"
								controlId="filterExpenseTypeId"
							>
								<FormControl
									as="select"
									className="form-search"
									value={filterExpenseTypeId}
									onChange={this.handleChangeSearch}
								>
									<option value="">{this.props.t("expenses.allCategories")}</option>
									{expense_types.length > 0 &&
										expense_types.map((item) => (
											<option key={item.id} value={item.id}>
												{item.name}
											</option>
										))}
								</FormControl>
							</FormGroup>

							<DateRangePicker
								startDateId="expense_startDate"
								endDateId="expense_endDate"
								startDate={startDate ? moment(startDate) : null}
								endDate={endDate ? moment(endDate) : null}
								startDatePlaceholderText={this.props.t("common.from")}
								endDatePlaceholderText={this.props.t("common.to")}
								onDatesChange={this.onDatesChange}
								focusedInput={focusedInput}
								onFocusChange={(focusedInput) =>
									this.setState({ focusedInput })
								}
								hideKeyboardShortcutsPanel={true}
								isOutsideRange={() => false}
								minimumNights={0}
							/>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.expensesReducer,
		loading: reducers.expensesReducer.loading,
		select_employees: reducers.employeesReducer.select_employees,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllExpenses: (options) =>
		dispatch(expensesActions.getAllExpenses(options)),
	getAllProviders: (options) =>
		dispatch(expensesActions.getAllProviders(options)),
	getAllExpenseTypes: (options) =>
		dispatch(expensesActions.getAllExpenseTypes(options)),
	getAllExpenseGroupings: (options) =>
		dispatch(expensesActions.getAllExpenseGroupings(options)),
	getAllPaymentTypes: (options) =>
		dispatch(expensesActions.getAllPaymentTypes(options)),
	getAllExpenseStatus: () => dispatch(expensesActions.getAllExpenseStatus()),
	getSelectableEmployees: () => dispatch(getSelectableEmployees()),
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Expenses));
